import $ from "jquery";
import "popper.js";
import "bootstrap";
import clamp from "clamp-js-main/clamp.js";

import {
    gsap,
    TweenMax,
    TimelineMax,
    CSSPlugin,
    Power0,
    Power1,
    Back
} from "gsap";
import Draggable from "gsap/Draggable";
import InertiaPlugin from "gsap/InertiaPlugin";
gsap.registerPlugin(Draggable, InertiaPlugin);
import Swiper from "swiper";
//import * as sergi from '../../js/extra/sergi.js';
import { theObject, globals, urls } from "../../js/main.js";

// HOME ANIMATION
export const homeAnimation = () => {
    const shapes = $(".shapes");
    const text = $(".text-start");
    const triangleAnim = () => {
        const easing = Power0.easeNone;
        const timeline1 = new TimelineMax({ repeat: -1, yoyo: true });
        const timeline2 = new TimelineMax({ repeat: -1, yoyo: true });
        const timeline3 = new TimelineMax({ repeat: -1, yoyo: true });

        timeline1
            .to("#t1", 1.45, {
                x: "+=65",
                y: "-=55",
                rotation: "+=45",
                ease: easing
            })
            .to("#t1", 1.45, {
                x: "+=25",
                y: "-=45",
                rotation: "+=40",
                ease: easing
            })
            .to("#t1", 1.45, {
                x: "-=55",
                y: "+=65",
                rotation: "+=40",
                ease: easing
            });

        timeline2
            .to("#t2", 1.65, {
                x: "-=30",
                y: "+=65",
                rotation: "-=25",
                ease: easing
            })
            .to("#t2", 1.65, {
                x: "-=45",
                y: "+=40",
                rotation: "-=25",
                ease: easing
            })
            .to("#t2", 1.65, {
                x: "-=25",
                y: "-=35",
                rotation: "+=40",
                ease: easing
            });

        timeline3
            .to("#t3", 2.1, {
                x: "-=70",
                y: "+=45",
                rotation: "+=40",
                ease: easing
            })
            .to("#t3", 2.1, {
                x: "-=50",
                y: "-=55",
                rotation: "+=40",
                ease: easing
            })
            .to("#t3", 2.1, {
                x: "+=45",
                y: "+=35",
                rotation: "+=40",
                ease: easing
            });
    };

    const linesAnim = () => {
        const easing = Power0.easeNone;
        const timeline1 = new TimelineMax({ repeat: -1, yoyo: true });
        const timeline2 = new TimelineMax({ repeat: -1, yoyo: true });
        const timeline3 = new TimelineMax({ repeat: -1, yoyo: true });

        timeline1
            .to("#l1", 1.6, {
                scaleX: `+=0.25`,
                y: `+=30`,
                rotation: `+=15`,
                ease: easing
            })
            .to("#l1", 1.6, {
                scaleX: `-=0.4`,
                y: `+=30`,
                rotation: `+=15`,
                ease: easing
            });

        timeline2
            .to("#l2", 1.65, {
                scaleX: `-=0.15`,
                y: `+=45`,
                rotation: `-=5`,
                ease: easing
            })
            .to("#l2", 1.7, {
                scaleX: `+=0.3`,
                y: `-=20`,
                rotation: `+=10`,
                ease: easing
            });

        timeline3
            .to("#l3", 1.7, {
                scaleX: `+=0.2`,
                y: `-=30`,
                rotation: `+=5`,
                ease: easing
            })
            .to("#l3", 2.05, {
                scaleX: `-=0.4`,
                y: `+=100`,
                rotation: `-=8`,
                ease: easing
            });
    };

    const diamondAnim = () => {
        const easing = Power1.easeInOut;
        const timeline1 = new TimelineMax({ repeat: -1, yoyo: true });
        const timeline2 = new TimelineMax({ repeat: -1, yoyo: true });
        const timeline3 = new TimelineMax({ repeat: -1, yoyo: true });

        timeline1.to("#d1", 1.4, {
            x: "-=45",
            y: "+=30",
            rotation: "-=280",
            ease: easing
        });

        timeline2
            .to("#d2", 2.3, {
                x: "-=140",
                y: "+=25",
                rotation: "+=400",
                ease: easing
            })
            .to("#d2", 2.3, { x: 0, y: 0, rotation: "+=400", ease: easing })
            .to("#d2", 2.3, {
                x: "+=75",
                y: "-=105",
                rotation: "+=400",
                ease: easing
            })
            .to("#d2", 2.3, {
                x: "-=60",
                y: 0,
                rotation: "+=400",
                ease: easing
            });

        timeline3.to("#d3", 1.9, {
            x: "-=120",
            y: "+=30",
            rotation: `+=470`,
            ease: easing
        });
    };

    const accAnim = () => {
        const easing = Power1.easeInOut;
        const timeline1 = new TimelineMax({ repeat: -1, yoyo: true });
        const timeline2 = new TimelineMax({ repeat: -1, yoyo: true });

        timeline1.to("#a1", 2.75, { x: "+=80", scale: "+=0.2", ease: easing });
        timeline2.to("#a2", 2.25, { x: "-=50", scale: "+=0.15", ease: easing });
    };

    TweenMax.fromTo(text, 0.5, { y: 25, autoAlpha: 0 }, { x: 0, autoAlpha: 1 });
    TweenMax.fromTo(
        shapes,
        0.8,
        { autoAlpha: 0, scale: 0 },
        {
            autoAlpha: 1,
            scale: 1,
            delay: 1,
            onComplete: function() {
                linesAnim();
                diamondAnim();
                accAnim();
                triangleAnim();
            }
        }
    );
};

// IMPLODE HOME // PAGE TRANSITION
export const pageTransition = () => {
    const audio = document.getElementById("audio");
    audio.preload = "auto";
    audio.volume = 0.3;
    const shapes = $(".shapes");
    const shapesContainer = $(".shapes-container");
    const body = $("body");

    $(".btn-section").click(function() {
        if (!$(this).hasClass("disabled")) {
            audio.play();
            const currentSection = $(this).closest("section");
            let nextSection = currentSection.next("section"); // ho canviarem a your selected materials

            const pageChange = () => {
                // Funció canvi de pàgina
                globals.animating = true;
                body.removeClass();
                TweenMax.to(currentSection, 0.4, {
                    x: -500,
                    autoAlpha: 0,
                    scale: "-=0.05",
                    delay: 0.2,
                    onComplete: function() {
                        TweenMax.fromTo(
                            nextSection,
                            0.4,
                            {
                                x: 500,
                                autoAlpha: 0,
                                scale: "-=0.05",
                                zIndex: 1
                            },
                            {
                                x: 0,
                                autoAlpha: 1,
                                scale: 1,
                                zIndex: 1,
                                delay: 0.5,
                                onComplete: function() {
                                    currentSection.removeClass("active");
                                    nextSection.addClass("active");
                                    body.addClass(nextSection.attr("id"));
                                    if (currentSection.hasClass("home")) {
                                        redoHome();
                                    }
                                    globals.animating = false;
                                }
                            }
                        );
                    }
                });
            };

            const redoHome = () => {
                // Recordem que el home s'havia encogit
                TweenMax.to(shapes, time, {
                    autoAlpha: 1,
                    scale: 1,
                    delay: delay
                });
                TweenMax.to(shapesContainer, time, {
                    rotation: 0,
                    scale: 1,
                    delay: delay
                });
            };

            const time = 0.8;
            const delay = 0.05;
            // Check special sections before changing
            if (currentSection.hasClass("selected-materials")) {
                // NEW: Form submit
                // get the form fields here
                var formFields = $("#clientForm").serializeArray();
                // Check that all fields are set

                if (
                    formFields[0].name == "name" &&
                    formFields[1].name == "company" &&
                    formFields[2].name == "jobTitle" &&
                    formFields[3].name == "email" &&
                    formFields[4].name == "consent1" &&
                    formFields[0].value != "" &&
                    formFields[2].value != "" &&
                    formFields[3].value != "" &&
                    formFields[4].value == "on" &&
                    new RegExp("[^@]+@[^.]+..+").test(formFields[3].value)
                ) {
                    // Send the request here
                    var objectToSend = theObject;
                    var result = $.post(`/api/clientSignup/${workshopId}`, {
                        client_id: objectToSend.client_id,
                        SelectedTopics: JSON.stringify(
                            objectToSend.SelectedTopics
                        ),
                        docsIds: JSON.stringify(objectToSend.SelectedDocs),

                        name: formFields[0].value,
                        company: formFields[1].value,
                        jobPosition: formFields[2].value,
                        email: formFields[3].value,

                        tick1: formFields[4].value,
                        tick2:
                            typeof formFields[5] === "undefined"
                                ? "off"
                                : formFields[5].value
                    });
                } else {
                    return;
                }

                const envelope = $(".envelope");
                nextSection = $("section.home");
                nextSection.addClass("thank-you");
                TweenMax.to(envelope, 1, {
                    y: -80,
                    delay: 0.2,
                    ease: Back.easeInOut,
                    onComplete: function() {
                        console.log(
                            "hi coder 🖖! Here is where the email sending is happening. All the info you need is in theObject, which I detail below:"
                        );
                        console.log(theObject);
                        pageChange();
                        setTimeout(function() {
                            const text = $(".text-end");
                            TweenMax.to(shapes, time, {
                                autoAlpha: 0,
                                scale: 2,
                                delay: delay
                            });
                            TweenMax.to(shapesContainer, time, {
                                rotation: -15,
                                scale: 2,
                                delay: delay,
                                onComplete: function() {
                                    TweenMax.to(text, 0.5, {
                                        y: -20,
                                        autoAlpha: 0,
                                        delay: 0.4,
                                        onComplete: function() {
                                            location.reload();
                                        }
                                    });
                                }
                            });
                        }, 30000);
                    }
                });
            } else if (currentSection.hasClass("home")) {
                // NEW: Skips client select section if it should be skipped
                if (globals.shouldSkipClientSection) {
                    nextSection = nextSection.next("section");
                    initTopicSelect(urls, theObject.client_id);
                    theObject.SelectedTopics = [];
                }

                if (currentSection.hasClass("thank-you")) {
                    // estem a la secció final, que té una animació diferent
                    const text = $(".text-end");
                    TweenMax.to(shapes, time, {
                        autoAlpha: 0,
                        scale: 2,
                        delay: delay
                    });
                    TweenMax.to(shapesContainer, time, {
                        rotation: -15,
                        scale: 2,
                        delay: delay,
                        onComplete: function() {
                            TweenMax.to(text, 0.5, {
                                y: -20,
                                autoAlpha: 0,
                                delay: 0.4,
                                onComplete: function() {
                                    location.reload();
                                }
                            });
                        }
                    });
                } else {
                    // estem a la primera secció
                    TweenMax.to(shapes, time, {
                        autoAlpha: 0,
                        scale: 0.5,
                        delay: delay
                    });
                    TweenMax.to(shapesContainer, time, {
                        rotation: 35,
                        scale: 0,
                        delay: delay,
                        onComplete: function() {
                            pageChange();
                        }
                    });
                }
            } else if (currentSection.hasClass("client")) {
                initTopicSelect(urls, theObject.client_id);
                pageChange();
                theObject.SelectedTopics = [];
            } else if (currentSection.hasClass("topics")) {
                initDocSelect(
                    urls,
                    theObject.client_id,
                    theObject.SelectedTopics
                );
                if (!globals.filtermodal) {
                    emptyFilterModal();
                    populateFilterModal(
                        urls.filterCats,
                        theObject.client_id,
                        theObject.SelectedTopics
                    );
                    globals.filtermodal = true;
                    setTimeout(function() {
                        $(".docselect .right-side .selected").click(function() {
                            backclicklistener();
                        });
                    }, 800);
                }
                pageChange();
            } else if (currentSection.hasClass("docselect")) {
                preSelectedMaterials();
                pageChange();
            } else {
                pageChange();
            }
        }
    });

    const backclicklistener = () => {
        audio.play();
        const currentSection = $("section.active");
        let prevSection = currentSection.prev("section");

        // NEW: Skip client section when pressing back
        if (prevSection.hasClass("client") && globals.shouldSkipClientSection) {
            prevSection = prevSection.prev("section");
        }

        const pageChange = () => {
            globals.animating = true;
            body.removeClass();
            TweenMax.to(currentSection, 0.4, {
                x: 500,
                autoAlpha: 0,
                scale: "-=0.05",
                delay: 0.2,
                onComplete: function() {
                    TweenMax.fromTo(
                        prevSection,
                        0.4,
                        { x: -500, autoAlpha: 0, scale: "-=0.05", zIndex: 1 },
                        {
                            x: 0,
                            autoAlpha: 1,
                            scale: 1,
                            zIndex: 1,
                            delay: 0.5,
                            onComplete: function() {
                                currentSection.removeClass("active");
                                prevSection.addClass("active");
                                body.addClass(prevSection.attr("id"));
                                globals.animating = false;
                            }
                        }
                    );
                }
            });
        };
        pageChange();
    };
    //Back behaviour
    $(".back").click(function() {
        if (!globals.animating) {
            if ($("section.docselect.active").length) {
                clearFilterTags();
                checkClearFilterBtnStatus(false);
                const yourfilterswiper = $(
                    ".filtermodal .selected-filters .swiper-container"
                ).get(0).swiper;
                if (typeof yourfilterswiper == "object") {
                    yourfilterswiper.update();
                    checkVScrollbar(
                        $(".your-filters-swiper-scrollbar"),
                        yourfilterswiper
                    );
                }
            }

            if (
                $("section.docselect.active .buttons-container.filtered-state")
                    .length
            ) {
                $("section.docselect .btn-clear").trigger("click");
            }

            backclicklistener();
        }
    });

    // Back to start behaviour DISCARDED!!
    /* const side = $('.side-blur');
    const backModal = $('.back-start-modal');
    const interrogationSign = $('.int-sign');
    TweenMax.set(backModal, { autoAlpha: 0, rotationX: 10, scale: 0.5 });
    TweenMax.set(interrogationSign, { autoAlpha: 0, scale: 0.5, transformOrigin: '50% 50%' });

    $('.back-start').click(function() { // Button fora del modal
    audio.play();
    $(this).addClass('modal-in');
    TweenMax.to(backModal, 0.4, {
    autoAlpha: 1, rotationX: 0, scale: 1, delay: 0.5, onComplete: function () {
    side.css('filter', 'blur(6px)');
    TweenMax.to(interrogationSign, 0.6, {autoAlpha: 1, scale: 1});
    }
    });
    });

    $('.cancel').click(function() {
    audio.play();
    $('.back-start').removeClass('modal-in');
    TweenMax.to(backModal, 0.4, {
    autoAlpha: 0, rotationX: 10, scale: 0.5, onComplete: function () {
    side.css('filter', 'blur(0px)');
    TweenMax.set(interrogationSign, { autoAlpha: 0, scale: 0.5 });
    }
    });
    });

    $('.back-to-start').click(function () { // Button dintre del modal
    audio.play();
    const currentSection = $('section.active');
    let homeSection = $('section.home');
    const pageChange = () => {
    TweenMax.to(currentSection, 0.4, {
    x: 500, autoAlpha: 0, scale: '-=0.05', delay: 0.2, onComplete: function () {
    TweenMax.fromTo(homeSection, 0.4, { x: -500, autoAlpha: 0, scale: '-=0.05', zIndex: 1 }, {
    x: 0, autoAlpha: 1, scale: 1, zIndex: 1, delay: 0.5, onComplete: function () {
    location.reload();
    }
    })
    }
    });
    }
    pageChange();
    });
    */
};

// DRAG&DROP
function dragDrop(firstTime) {
    const dropArea = $("#drop-big");
    const droppables = $(".doc");
    const instructions = $(".instructions");
    const overlapThreshold = "60%";
    let dropSwiper;

    if (typeof $(".drop-swiper-container").get(0).swiper != "object") {
        dropSwiper = new Swiper(".drop-swiper-container", {
            direction: "vertical",
            slidesPerView: 3,
            mousewheel: true
            //autoHeight: true
        });
    } else {
        dropSwiper = $(".drop-swiper-container").get(0).swiper;
        dropSwiper.update();
    }

    const rearrangeDocs = doc => {
        //console.log(countDocsNumber);
        // which is the last document before the hole?

        let placenumber = -1;
        let whereto, wherefrom, dropZone;
        $(".docselect .right-side .drop-zone").each(function(index) {
            //console.log('i' + index);
            let thedoc = $(this).find(".doc");
            if (thedoc.length == 0 && placenumber == -1) {
                placenumber = index;
                dropZone = $(this);
            } else if (placenumber != -1) {
                // we take the doc (if exists!)
                if (thedoc.length) {
                    //we free the dropZone so next iteration takes the good one
                    // this drop-zone is transformed into the new drop-zone
                    const thisDropZone = dropZone;
                    dropZone = thedoc.parent();
                    let boundsto = thisDropZone.get(0).getBoundingClientRect();
                    let boundsfrom = thedoc.get(0).getBoundingClientRect();

                    // we animate to the drop-zone
                    TweenMax.fromTo(
                        thedoc.get(0),
                        0.3,
                        { x: 0, y: 0 },
                        {
                            x: "+=" + (boundsto.left - boundsfrom.left),
                            y: "+=" + (boundsto.top - boundsfrom.top),
                            onComplete: function() {
                                // we append the dom and remove styles
                                thedoc
                                    .appendTo(thisDropZone)
                                    .removeAttr("style");
                                TweenMax.set(thedoc, {
                                    x: 0,
                                    y: 0,
                                    zIndex: 1000
                                });
                                nextDropAdjust();
                            }
                        }
                    );
                }
            }
        });

        // NEW: Fixes the scrollbar
        let smth = [];
        $(".docselect .drop-zone .doc").each(function() {
            smth.push($(this).data("doc_id"));
        });

        let number = 6;
        if (theObject.SelectedTopics && theObject.SelectedTopics.length > 0) {
            number = 5;
        }
        if (smth.length > number) {
            createSlide(false);
            console.log("creating slider");
        } else {
            destroySlide();
            console.log("deleting slider");
        }

        // we update the next-drop and remove unused slides if necessary
    };

    function clickDestroyListener(el) {
        const cross = $(el).find(".cross");
        cross.click(function() {
            let doc = $(this).closest(".doc");
            TweenMax.to(doc, 0.4, {
                scale: 0,
                autoAlpha: 0,
                rotation: "+=35",
                onComplete: function() {
                    if (doc.hasClass("dropped")) {
                        //estem destruint elements de la dreta
                        countMinus();
                        doc.remove();
                        nextDropAdjust();

                        const dropArea = $("#drop-big");
                        const instructions = $(".instructions");
                        if (dropArea.find(".doc").length < 1) {
                            instructions.removeClass("hidden");
                        } else {
                            rearrangeDocs();
                        }
                    } else {
                        // destruim elements de la esquerra
                        leftSideDestroyDocAction(doc, urls.docRegeneration);
                    }
                    disableDrag();
                }
            });
        });
    }

    function leftSideDestroyDocAction(doc, url) {
        let dataDoc = doc.closest(".drag-zone .doc");
        docRegeneration(url, dataDoc.data("doc_id"), 1, dataDoc.parent());
        doc.remove();
    }

    function draggableListener(el) {
        Draggable.create(el, {
            type: "x,y",
            bounds: "#docselect",
            inertia: true,
            throwResistance: 2500,
            maxDuration: 1,
            edgeResistance: 0.95,
            minimumMovement: 10,
            allowContextMenu: true,
            onDrag: function() {
                if (this.hitTest(dropArea, overlapThreshold)) {
                    instructions.addClass("hidden");
                } else if (dropArea.find(".doc").length < 1) {
                    instructions.removeClass("hidden");
                }
            },
            onThrowComplete: dropItem
        });
    }

    function dropItem() {
        // TODO: PR2 when the doc is dropped in the swiper that is up, it should scroll down to last slide too
        let boundsBefore, boundsAfter;
        const dataDoc = $(this.target).closest(".drag-zone .doc");
        const dataDocParent = dataDoc.parent();
        if (this.hitTest(dropArea, overlapThreshold)) {
            // NEW: If the doc is already selected don't let it drop and send it back
            var docIdArray = [];
            $(".docselect .drop-zone .doc").each(function() {
                docIdArray.push($(this).data("doc_id"));
            });
            if (docIdArray.indexOf(dataDoc.data("doc_id")) > -1) {
                TweenMax.to(this.target, 0.5, {
                    x: 0,
                    y: 0
                });
                return;
            }

            instructions.addClass("hidden");
            boundsBefore = this.target.getBoundingClientRect();
            $(this.target)
                .appendTo(".next-drop")
                .addClass("dropped")
                .find("h3")
                .addClass("webkitClamp");
            $(this.target)
                .find(".cover")
                .off("click");
            disableDrag();
            boundsAfter = this.target.getBoundingClientRect();
            TweenMax.fromTo(
                this.target,
                0.3,
                {
                    x: "+=" + (boundsBefore.left - boundsAfter.left),
                    y: "+=" + (boundsBefore.top - boundsAfter.top)
                },
                {
                    x: 0,
                    y: 0,
                    onComplete: function() {
                        const dropSwiper = $(".drop-swiper-container").get(0)
                            .swiper;
                        countPlus();
                        nextDropAdjust();
                        dropSwiper.slideTo(dropSwiper.slides.length, 600);
                        docRegeneration(
                            urls.docRegeneration,
                            dataDoc.data("doc_id"),
                            0,
                            dataDocParent
                        );
                    }
                }
            );
        } else {
            TweenMax.to(this.target, 0.5, { x: 0, y: 0 });
        }

        // NEW: Update the id array
        var docIdArray = [];
        $(".docselect .drop-zone .doc").each(function() {
            docIdArray.push($(this).data("doc_id"));
        });
        theObject.SelectedDocs = docIdArray;
    }

    var countDocsNumber = $(".drop-swiper-container .doc").length;

    function countPlus() {
        countDocsNumber++;

        if (
            countDocsNumber % 2 != 0 &&
            countDocsNumber >= 5 &&
            $(".drop-swiper-container .selected ").length
        ) {
            createSlide();
        } else if (
            countDocsNumber % 2 == 0 &&
            countDocsNumber >= 6 &&
            !$(".drop-swiper-container .selected").length
        ) {
            createSlide();
        }
        return countDocsNumber;
    }

    function countMinus() {
        countDocsNumber--;
        return countDocsNumber;
    }

    function createSlide(shouldSlide = true) {
        const lastSlide = $(".drop-swiper-container .swiper-slide")
            .last()
            .data("slide");
        let newSlide = `<div class="swiper-slide" data-slide="${lastSlide +
            1}"><div class="drop-zone"></div><div class="drop-zone"></div></div>`;

        if (shouldSlide) {
            dropSwiper.appendSlide(newSlide);
            dropSwiper.update();
            dropSwiper.slideTo(dropSwiper.slides.length, 600);
        }
        nextDropAdjust();
        TweenMax.to(".vertical-arrow-swiper", 1, { autoAlpha: 1 });
    }

    const destroySlide = () => {
        const slide = $(".drop-swiper-container .swiper-slide");
        const numberOfSlides = slide.length;
        slide.each(function() {
            let dataSlide = $(this).data("slide");
            if (
                numberOfSlides > 3 &&
                dataSlide != 1 &&
                $(this).find(".doc").length == 0
            ) {
                $(this).remove();
                dropSwiper.slidePrev(600);
                dropSwiper.update();
                nextDropAdjust();

                if ($(".next-drop").length == 0) {
                    createSlide();
                } else {
                    TweenMax.to(".vertical-arrow-swiper", 1, { autoAlpha: 0 });
                }
            }
        });
    };

    function disableDrag() {
        setTimeout(function() {
            $(".dropped").each(function() {
                Draggable.get(this).disable();
            });
        }, 500);
    }

    $(".docselect .left-side .content-container .doc").each(function() {
        clickDestroyListener(this); //listener
        draggableListener(this);
    });

    function docRegenerateMarkup(doc, realDocParent) {
        const dragZones = $(".drag-zone");
        const newPost = {
            doc_id: doc.doc_id,
            doc_title: doc.doc_title,
            doc_url: doc.doc_url,
            doc_images_collection: doc.doc_images_collection,
            doc_type: doc.doc_type,
            doc_image_preview: doc.doc_image_preview,
            doc_hashtags: doc.doc_hashtags
        };

        //console.log(realDocParent.find('.doc').length);
        //if (realDocParent.find('.doc').length != 1) {
        realDocParent.append(
            `<div class="doc draggable">
          <div class="cover" style="background-image: url(${
              newPost.doc_image_preview
          });">
            <div class="cross"></div>
            <div class="view"></div>
          </div>
          <div class="title-wrapper">
            <h3>${newPost.doc_title}</h3>
          </div>
        </div>`
        );
        const newDoc = realDocParent.children(".doc");
        newDoc
            .data("doc_id", newPost.doc_id)
            .data("doc_url", newPost.doc_url)
            .data("doc_title", newPost.doc_title)
            .data("doc_images_collection", newPost.doc_images_collection)
            .data("doc_type", newPost.doc_type)
            .data("doc_hashtags", newPost.doc_hashtags);

        clamp(
            $(newDoc)
                .find("h3")
                .get(0),
            { clamp: 2, useNativeClamp: false }
        );

        TweenMax.fromTo(
            newDoc,
            0.6,
            { autoAlpha: 0, scale: 0.95, y: 30, display: "block" },
            {
                autoAlpha: 1,
                scale: 1,
                y: 0,
                display: "block",
                delay: 0.5,
                onComplete: function() {
                    clickDestroyListener(newDoc); // ojo! es un listener
                    draggableListener(newDoc); // ojo! es un listener
                    modalListener(newDoc); // ojo! es un listener
                    newDoc.removeClass("new-doc");
                    //clamp($(newDoc).find('h3').get(0), {clamp: 2});
                }
            }
        );
        //}
    }

    async function docRegeneration(url, doc_id, action, realDocParent) {
        // Get the selected tags
        let filterTags = [];
        $(".cattags-container .btn-hashtag.selected").each((index, el) => {
            filterTags.push($(el).data("tag-id"));
        });

        // Get the selected docs
        var docIdArray = [];
        $(".docselect .drop-zone .doc").each(function() {
            docIdArray.push($(this).data("doc_id"));
        });
        var result = await $.post(urls.docRegeneration, {
            selectedDocsId: JSON.stringify(docIdArray),
            otherDocsIds: JSON.stringify(theObject.notSelectedIds),
            removedDocId: doc_id,
            tags: JSON.stringify(filterTags),
            action: action
        });

        if (result) {
            var newDoc =
                typeof result === "string" || result instanceof String
                    ? JSON.parse(result)
                    : result;

            docRegenerateMarkup(newDoc, realDocParent);
            theObject.notSelectedIds.push(newDoc.doc_id);
        }

        // Remove old id from the not selected and add a new one
        var index = theObject.notSelectedIds.indexOf(doc_id);
        if (index > -1) {
            theObject.notSelectedIds.splice(index, 1);
        }
    }

    function applyFilter(whichmodal) {
        let filterTags = [];
        // revisamos todos los hashtags que tienen select en la izquierda y los enviamos al JSON
        $(".cattags-container .btn-hashtag.selected").each((index, el) => {
            filterTags.push($(el).data("tag-id"));
        });

        // llamar a JSON para nuevos documentos (igual que docselect)

        initDocSelect(
            urls,
            theObject.client_id,
            theObject.SelectedTopics,
            false
        );
        closeModal(whichmodal);
        $(".docselect .buttons-container").addClass("filtered-state");

        // $.post(urls.filterDocs, {
        //     filterTags: filterTags,
        // })
        //     .done(function (json) {
        //         // check if save option should be true
        //         let saveOption = !$('.btn-clear').parent().hasClass('filtered-state');
        //         $("doc-container").empty()

        //         populateDocSelectSection(JSON.parse(json), true, saveOption, false);

        //         closeModal(whichmodal);
        //         $('.docselect .buttons-container').addClass('filtered-state');
        //     });
    }

    function revokeFilterDocs() {
        // destroy current docs with animations
        const destroyDocs = $(
            "section.docselect .left-side .content-container .doc"
        );
        const savedStateContainer = $(".savedState");
        const leftSideContainer = $(
            "section.docselect .left-side .content-container"
        );

        gsap.to(destroyDocs, {
            duration: 0.4,
            delay: 0.4,
            scale: 0,
            autoAlpha: 0,
            rotation: "+=35",
            onComplete: function() {
                leftSideContainer.empty();
                // move again all savedDocs, and animate entrance
                savedStateContainer.children().appendTo(leftSideContainer);

                $(
                    "section.docselect .left-side .content-container .doc h3"
                ).each((index, el) => {
                    clamp(el, { clamp: 2, useNativeClamp: false });
                });

                gsap.fromTo(
                    leftSideContainer.find(".doc"),
                    0.6,
                    {
                        autoAlpha: 0,
                        scale: 0.95,
                        y: 30,
                        display: "block",
                        rotation: 0
                    },
                    {
                        autoAlpha: 1,
                        scale: 1,
                        y: 0,
                        display: "block",
                        rotation: 0,
                        delay: 0.5,
                        onComplete: function() {
                            // destroy savedState div
                            savedStateContainer.remove();
                        }
                    }
                );
            }
        });
    }

    if (firstTime) {
        $(".btn-apply-sel").click(event => {
            applyFilter($(event.currentTarget).closest(".filtermodal"));
        });
        $(".btn-clear").click(event => {
            clearFilterTags();
            $(event.currentTarget)
                .parent()
                .removeClass("filtered-state");
            // TODO Check this. Was commented, but uncommented on the Old file
            // revokeFilterDocs();
        });

        $(".btn-tag-modal-no").click(event => {
            const id = $(".tags-modal").data("tag-id");
            console.log(id);
            // TODO we have to deselect it here
            $(".filter-tags-container")
                .find('.btn-hashtag[data-tag-id="' + id + '"]')
                .trigger("click");
            $(".hashtag-container .btn-hashtag.selected").each((index, el) => {
                if ($(el).data("tag-id") == id) {
                    $(el).removeClass("selected");
                }
            });
            gsap.to($(".tags-modal"), { duration: 0.7, autoAlpha: 0 });
            gsap.to($(".docmodal .col-right .swiper-container"), {
                duration: 1,
                autoAlpha: 1
            });
        });

        $(".btn-tag-modal-yes").click(event => {
            applyFilter($(event.currentTarget).closest(".docmodal"));
        });
    }
}

// MODAL INITIALIZATION
export const hideTheModal = theModal => {
    TweenMax.set(theModal, { autoAlpha: 0, rotationX: 10, scale: 0.5 });
};

function showModal(theModal, callback) {
    TweenMax.to(theModal, 0.4, {
        autoAlpha: 1,
        rotationX: 0,
        scale: 1,
        delay: 0.5,
        onComplete: function() {
            if (globals.device != "hub" && globals.device != "ipad") {
                $(".vertical-blur").removeClass("d-none");
                $(".side-blur").css("filter", "blur(0.38rem)");
            }
            $("button.back").addClass("modal-in");
            //modalSwiper();
            callback();
        }
    });
}

function closeModal(modal) {
    if (globals.device != "hub" && globals.device != "ipad") {
        $(".side-blur").css("filter", "blur(0px)");
        $(".vertical-blur").addClass("d-none");
    }

    $("button.back").removeClass("modal-in");
    TweenMax.to(modal, 0.4, { autoAlpha: 0, rotationX: 10, scale: 0.5 });
}

// POPUP TRANSITION
function modalListener(el) {
    const theModal = $(".docmodal");
    const cover = $(el).find(".cover");

    const click = el => {
        const container = $(el).closest(".drag-zone .doc");
        $(".last-selected-doc").removeClass("last-selected-doc");
        container.addClass("last-selected-doc");
        preDocModal(container);
        $(".tags-swiper-scrollbar")
            .addClass("scrollbar-none sb-invisible")
            .removeClass("sb-visible");
        showModal(theModal, modalSwiper); // modalSwiper es el callback
    };

    let clicked = false;
    cover.click(event, function() {
        // the monkey developed Safari for iOS calls the click twice for unkwnown reasons. We prevent it with clicked tag:
        if (!$(event.target).hasClass("cross")) {
            if (!clicked) {
                clicked = true;
                click(this);
                setTimeout(() => {
                    clicked = false;
                }, 200);
            }
        }
    });

    $(".docmodal .cross").click(event =>
        closeModal($(event.currentTarget).closest(".docmodal"))
    );
}

// HAND ICON ANIMATION
export const selectAnimation = () => {
    const hand = $(".hand");
    const triangles = $(".instructions__svg .f");
    const diamonds = $(".instructions__svg .e");
    const line = $(".instructions__svg .g");
    const tl = new TimelineMax({ repeat: -1 });
    const easing = Power0.easeNone;

    const triangleAnim = elem => {
        const tl = new TimelineMax({ repeat: -1, yoyo: true });
        const rT = Math.floor(Math.random() * 0.5) + 1;
        const rR = Math.floor(Math.random() * 5);
        const rX1 = Math.floor(Math.random() * 10) - 5;
        const rY1 = Math.floor(Math.random() * 20) - 10;
        const rX2 = Math.floor(Math.random() * 10) - 5;
        const rY2 = Math.floor(Math.random() * 20) - 10;

        tl.to(elem, rT, {
            x: `+=${rX1}`,
            y: `+=${rY1}`,
            rotation: `+=${rR}`,
            ease: easing
        }).to(elem, rT, {
            x: `+=${rX2}`,
            y: `+=${rY2}`,
            rotation: `+=${rR}`,
            ease: easing
        });
    };

    const diamondAnim = elem => {
        const tl = new TimelineMax({ repeat: -1, yoyo: true });
        const randomTime = Math.floor(Math.random() * 3) + 1;
        const randomRotation = Math.floor(Math.random() * 360) - 180;

        tl.to(elem, randomTime, {
            rotation: `+=${randomRotation}`,
            transformOrigin: "50% 50%",
            ease: Power1.easeInOut
        });
    };

    const linesAnim = elem => {
        const tl = new TimelineMax({ repeat: -1, yoyo: true });
        const randomScaleX = Math.random() * 0.25;
        const randomY = Math.floor(Math.random() * 5) + 10;

        tl.to(elem, 2.5, {
            scaleX: `+=${randomScaleX}`,
            y: `+=${randomY}`,
            ease: Power1.easeInOut
        });
    };

    TweenMax.set(hand, { x: -15 });
    tl.to(hand, 1.4, { x: 15, ease: Power1.easeInOut }).to(hand, 0.8, {
        x: -15,
        ease: Power1.easeInOut
    });

    triangles.each(function() {
        triangleAnim(this);
    });

    diamonds.each(function() {
        diamondAnim(this);
    });

    line.each(function() {
        linesAnim(this);
    });
};

// EMAIL ANIMATION
export const emailAnimation = () => {
    const triangles = $(".email__svg .h");
    const diamonds = $(".email__svg .g");
    const line = $(".email__svg .l");
    const easing = Power0.easeNone;

    const triangleAnim = elem => {
        const tl = new TimelineMax({ repeat: -1, yoyo: true });
        const rT = Math.floor(Math.random() * 0.5) + 1;
        const rR = Math.floor(Math.random() * 5);
        const rX1 = Math.floor(Math.random() * 10) - 5;
        const rY1 = Math.floor(Math.random() * 20) - 10;
        const rX2 = Math.floor(Math.random() * 10) - 5;
        const rY2 = Math.floor(Math.random() * 20) - 10;

        tl.to(elem, rT, {
            x: `+=${rX1}`,
            y: `+=${rY1}`,
            rotation: `+=${rR}`,
            ease: easing
        }).to(elem, rT, {
            x: `+=${rX2}`,
            y: `+=${rY2}`,
            rotation: `+=${rR}`,
            ease: easing
        });
    };

    const diamondAnim = elem => {
        const tl = new TimelineMax({ repeat: -1, yoyo: true });
        const randomTime = Math.floor(Math.random() * 3) + 1;
        const randomRotation = Math.floor(Math.random() * 360) - 180;

        tl.to(elem, randomTime, {
            rotation: `+=${randomRotation}`,
            transformOrigin: "50% 50%",
            ease: Power1.easeInOut
        });
    };

    const linesAnim = elem => {
        const tl = new TimelineMax({ repeat: -1, yoyo: true });
        const randomScaleX = Math.random() * 0.25;
        const randomY = Math.floor(Math.random() * 30) - 15;

        tl.to(elem, 2.5, {
            scaleX: `+=${randomScaleX}`,
            y: `+=${randomY}`,
            ease: Power1.easeInOut
        });
    };

    triangles.each(function() {
        triangleAnim(this);
    });

    diamonds.each(function() {
        diamondAnim(this);
    });

    line.each(function() {
        linesAnim(this);
    });
};

// HAND MODAL ANIMATION
export const handModalAnimation = () => {
    const hand = $(".hand-modal__svg .f");
    const tl = new TimelineMax({ repeat: -1 });

    TweenMax.set(hand, { x: -25 });
    tl.to(hand, 1.2, { x: 25, ease: Power1.easeInOut }).to(hand, 1.2, {
        x: -25,
        ease: Power1.easeInOut
    });
};

// MODAL SWIPER
export function modalSwiper() {
    // swiper init for the preview doc
    new Swiper($("section.docselect .docmodal .col-left .swiper-container"), {
        speed: 400,
        slidesPerView: "auto",
        mousewheel: true
    });

    // swiper init for the hashtags
    const swiperel = new Swiper(
        $("section.docselect .docmodal .col-right .swiper-container"),
        {
            direction: "vertical",
            slidesPerView: "auto",
            freeMode: true,
            scrollbar: {
                el: ".tags-swiper-scrollbar"
            },
            mousewheel: true
        }
    );

    checkVScrollbar($(".tags-swiper-scrollbar"), swiperel);
    // setTimeout(() => {
    //   $('.tags-swiper-scrollbar').removeClass('scrollbar-none');
    // }, 200);
}

// NEXT DROP ADJUST
export const nextDropAdjust = () => {
    $(".next-drop").removeClass("next-drop");
    $(".drop-zone").each(function(element) {
        if ($(this).find(".doc").length < 1) {
            $(this).addClass("next-drop");
            return false;
        }
    });
};

function clientSelect() {
    $("section.client button.client-container").on("click", function() {
        $("button.client-container.active").each(function() {
            $(this).removeClass("active");
        });
        $(this).addClass("active");
        $("section.client").removeClass("no-client");
        theObject.client_id = $(this).data("client_id");
    });
}

function topicSelect() {
    $("section.topics button.topic-container:not(.select-all)").on(
        "click",
        function() {
            $(this).toggleClass("active");
            theObject.SelectedTopics = [];
            $("section.topics button.topic-container.active").each(function() {
                theObject.SelectedTopics.push($(this).data("topic_id"));
            });
        }
    );

    $("section.topics button.topic-container.select-all").on(
        "click",
        function() {
            var allselector = $(
                "section.topics button.topic-container:not(.select-all):not(.active)"
            );
            if (allselector.length) {
                allselector.addClass("active");
            } else {
                $("section.topics button.topic-container.active").removeClass(
                    "active"
                );
            }
            theObject.SelectedTopics = [];
            $("section.topics button.topic-container.active").each(function() {
                theObject.SelectedTopics.push($(this).data("topic_id"));
            });
        }
    );
}

export function whichRatio() {
    var ratio = $(window).width() / $(window).height();
    var device = "ipad";

    // 1.5 surface
    // 1.78 hub
    // 1.33 ipad

    if (ratio > 1.7) {
        device = "hub";
    } else if (ratio > 1.48) {
        device = "surface";
    }

    return device;
}

function initClientSection(clients) {
    var length = clients.length;

    // NEW: Set if we should skip the client section
    console.log("clients: ", length);

    globals.shouldSkipClientSection = length <= 1;
    if (globals.shouldSkipClientSection) {
        theObject.client_id =
            theObject.workshopType == 2 ? -69 : clients[0].client_id;
    }

    var device = globals.device;
    var clientsPerSlide = 8;
    var slideHTML = '<div class="swiper-slide"><div class="row"></div></div>';
    var clientHTML =
        '<button class="client-container"><div class="client-frame"><div class="gradient-cover"></div><div class="client-bg"></div></div></button>';

    if (window.innerWidth >= 1200) {
        clientsPerSlide = 12;
    } else if (window.innerWidth >= 992) {
        clientsPerSlide = 10;
    }

    var SlidesNumber = parseInt((length - 1) / clientsPerSlide) + 1;
    var i = SlidesNumber;
    let jc = 0;

    for (var i = 1; i <= SlidesNumber; i++) {
        // create slide
        $("section.client .swiper-wrapper").append(slideHTML);
        let j = 1;

        while (j <= clientsPerSlide && jc < length) {
            var client_id = clients[jc].client_id;
            var imageUrl = clients[jc].client_logo_url;
            $("section.client .swiper-slide:last-child .row").append(
                clientHTML
            );
            $(
                "section.client .swiper-slide:last-child .row button.client-container:last-child"
            ).data("client_id", client_id);
            $(
                "section.client .swiper-slide:last-child .row button.client-container:last-child .client-bg"
            ).css("background-image", "url(" + imageUrl + ")");
            j++;
            jc++;
        }
    }
    // activate swiper (if there are more than 1 slide)
    if (SlidesNumber > 1) {
        //initialize swiper when document ready
        new Swiper("section.client .swiper-container", {
            // Optional parameters
            pagination: {
                el: "section.client .swiper-pagination",
                clickable: true
            },
            mousewheel: true
        });
    }

    clientSelect();
}

export function initClients(urls) {
    $.getJSON(urls.clients).done(function(json) {
        initClientSection(json);
    });
}

function populateDocSelectSection(docs, animated, save, firstTime) {
    let docHTML =
        '<div class="drag-zone"><div class="doc draggable"><div class="cover"><div class="cross"></div><div class="view"></div></div><div class="title-wrapper"><h3></h3></div></div></div>';
    let itemNum = 6;

    // save current State in div dnone if save option == true #savestate
    const contentContainer = $(
        "section.docselect .left-side .content-container"
    );
    if (save) {
        saveCurrentState(contentContainer);
    }
    // empty previous generation of docs

    // animate the destruction if animated==true
    if (animated) {
        const destroyDocs = contentContainer.find(".doc");
        //const destroyDocsLength = destroyDocs.length;

        gsap.to(destroyDocs, {
            duration: 0.4,
            delay: 0.4,
            scale: 0,
            autoAlpha: 0,
            rotation: "+=35",
            onComplete: function() {
                leftSideEmptyAndGenerate(animated);
            }
        });
    } else {
        leftSideEmptyAndGenerate(animated);
    }

    // If there are docs in the right, save them in an array to place them back

    let isFull = $("section.docselect .right-side .doc").length > 0;
    let topicsSelected = theObject.SelectedTopics.length > 0;
    const selectedHTML =
        '<div class="selected"><div class="cover"><div class="cover-corrected"></div></div><div class="title-wrapper"><h3>Material from your' +
        " session(s)</h3></div></div>";

    if (!isFull) {
        $("section.docselect .right-side .swiper-wrapper")
            .empty()
            .append(
                '<div class="swiper-slide" data-slide="1"><div class="drop-zone next-drop"></div><div class="drop-zone"></div></div><div class="swiper-slide" data-slide="2"><div class="drop-zone"></div><div class="drop-zone"></div></div><div class="swiper-slide" data-slide="3"><div class="drop-zone"></div><div class="drop-zone"></div></div>'
            );

        if (topicsSelected) {
            //there is at least one selected
            // remove one drop-zone
            $(
                "section.docselect .right-side .swiper-slide:first-child .drop-zone:first-child"
            ).remove();

            // prepend the html
            $(
                "section.docselect .right-side .swiper-slide:first-child"
            ).prepend(selectedHTML);
        }
    } else {
        // Now we have 2 options: we mantain the topics situation, or we don't
        // if we mantain, we don't do anything
        // if we don't, we have to move all the docs to accomodate the new situation
        if (
            !topicsSelected &&
            $("section.docselect .right-side .selected").length > 0
        ) {
            // we didn't select topics, but there is a selected document: we remove selected and move all the docs to the left
            // remove select
            $("section.docselect .right-side .selected").remove();
            // move all the docs
            $("section.docselect .right-side .drop-zone").each(function(index) {
                if (index % 2 != 0) {
                    // Si es el documento segundo, cuarto, etc... se cambia a la slide anterior
                    let prevSlide = $(this)
                        .parent()
                        .prev();
                    $(this).appendTo(prevSlide);
                }
            });

            // check if there is a slide without next drop and remove
            setTimeout(function() {
                const dropSwiper = $(".drop-swiper-container").get(0).swiper;
                const slide = $(".drop-swiper-container .swiper-slide");
                const numberOfSlides = slide.length;
                slide.each(function() {
                    const dataSlide = $(this).data("slide");
                    if (
                        numberOfSlides > 3 &&
                        dataSlide != 1 &&
                        $(this).find(".doc").length == 0
                    ) {
                        //$(this).remove();
                        //dropSwiper.slidePrev(600);
                        dropSwiper.update();
                        nextDropAdjust();
                    }
                });

                if (slide.last().find(".drop-zone").length == 1) {
                    slide.last().append('<div class="drop-zone"></div>');
                }

                if (
                    numberOfSlides > 3 &&
                    !slide.last().find(".doc").length &&
                    !slide.last().find(".next-drop").length
                ) {
                    slide.last().remove();
                    dropSwiper.update();
                }
            }, 500);
        } else if (
            topicsSelected &&
            $("section.docselect .right-side .selected").length == 0
        ) {
            //we selected some topics, but there is not a selected document: we create the selected document and move all the docs to the right
            $(
                "section.docselect .right-side .swiper-slide:first-child"
            ).prepend(selectedHTML);
            // move all the docs
            $("section.docselect .right-side .drop-zone").each(function(index) {
                if (index % 2 != 0) {
                    // Si es el documento segundo, cuarto, etc... se cambia a la slide siguiente
                    let nextSlide = $(this)
                        .parent()
                        .next();
                    $(this).prependTo(nextSlide);
                }
            });
            const numberOfSlides = $(
                "section.docselect .right-side .swiper-slide"
            ).length;
            //if there are 3 items in last slide, just remove last
            const lastSlide = $(
                "section.docselect .right-side .swiper-slide"
            ).last();

            if (lastSlide.find(".drop-zone").length == 3) {
                lastSlide
                    .find(".drop-zone")
                    .last()
                    .remove();
            }

            if (numberOfSlides >= 3 && !lastSlide.find(".next-drop").length) {
                //add new slide and go
                const dropSwiper = $(".drop-swiper-container").get(0).swiper;
                const lastSlideNum = $(".drop-swiper-container .swiper-slide")
                    .last()
                    .data("slide");
                let newSlide = `<div class="swiper-slide" data-slide="${lastSlideNum +
                    1}"><div class="drop-zone"></div><div class="drop-zone"></div></div>`;
                dropSwiper.appendSlide(newSlide);
                dropSwiper.update();
                //dropSwiper.slideTo(dropSwiper.slides.length, 600);
                nextDropAdjust();
            }
        }
    }

    if (!animated) {
        setTimeout(function() {
            dragDrop(firstTime);
            nextDropAdjust();
            $(".left-side .content-container .doc").each(function() {
                modalListener($(this));
            });
        }, 200);
    }

    function saveCurrentState(contentContainer) {
        // create a sibling of contentContainer with display none
        contentContainer.after('<div class="savedState d-none">');
        // move all the current docs to there with all the events
        contentContainer.children().appendTo(contentContainer.next());
        // leave a copy without event handlers just to make animations
        contentContainer
            .next()
            .children()
            .clone()
            .appendTo(contentContainer);
    }

    function leftSideEmptyAndGenerate(animated) {
        contentContainer.empty();

        let execute = false;
        for (let i = 0; i < itemNum; i++) {
            if (!docs[i]) continue;
            let attrs = {
                doc_id: docs[i].doc_id,
                doc_title: docs[i].doc_title,
                doc_url: docs[i].doc_url,
                doc_images_collection: docs[i].doc_images_collection,
                doc_type: docs[i].doc_type,
                doc_image_preview: docs[i].doc_image_preview,
                doc_hashtags: docs[i].doc_hashtags
            };
            let docselect = $(
                "section.docselect .left-side .content-container"
            );
            docselect.append(docHTML);
            const appended = docselect.children(".drag-zone:last-child");
            appended
                .children(".doc")
                .data("doc_id", attrs.doc_id)
                .data("doc_url", attrs.doc_url)
                .data("doc_title", attrs.doc_title)
                .data("doc_images_collection", attrs.doc_images_collection)
                .data("doc_type", attrs.doc_type)
                .data("doc_hashtags", attrs.doc_hashtags);

            appended
                .find(".cover")
                .css(
                    "background-image",
                    "url(" + attrs.doc_image_preview + ")"
                );
            appended.find("h3").text(attrs.doc_title);
            let h3sel = appended.find("h3").get(0);
            clamp(h3sel, { clamp: 2, useNativeClamp: false });

            // Animate the aparition of this doc
            if (i == itemNum - 1) {
                execute = true;
            }
            if (animated) {
                const length = appended.children(".doc").length;
                gsap.fromTo(
                    appended.children(".doc"),
                    0.6,
                    { autoAlpha: 0, scale: 0.95, y: 30, display: "block" },
                    {
                        autoAlpha: 1,
                        scale: 1,
                        y: 0,
                        display: "block",
                        delay: 0.5,
                        onComplete: function() {
                            // we search for the docs and add the destroy, drag and modal listeners:
                            if (execute) {
                                // we just want to execute one time, this is the flag's purpose.
                                execute = false;
                                dragDrop(false);
                                $(".left-side .content-container .doc").each(
                                    function() {
                                        modalListener($(this));
                                    }
                                );
                                nextDropAdjust();
                                // Update Swiper (don't know why it gets crowded after this)
                                $(".drop-swiper-container")
                                    .get(0)
                                    .swiper.update();
                                // as a matter of fact, this execution isn't necessary on complete as the doc is created before the animation, but let's mantain it here for readability purposes
                            }
                        }
                    }
                );
            }
        }
    }
}

async function initDocSelect(urls, client_id, topics) {
    let filterTags = [];
    // revisamos todos los hashtags que tienen select en la izquierda y los enviamos al JSON
    $(".cattags-container .btn-hashtag.selected").each((index, el) => {
        filterTags.push($(el).data("tag-id"));
    });

    var itemNum = 6;

    var docIdArray = [];
    $(".docselect .drop-zone .doc").each(function() {
        docIdArray.push($(this).data("doc_id"));
    });
    var result = await $.post(urls.docselect, {
        numberOfItems: itemNum,

        selectedDocsId: JSON.stringify(docIdArray),
        otherDocsIds: JSON.stringify(theObject.notSelectedIds),
        client_id: client_id,
        topics: topics,
        tags: JSON.stringify(filterTags)
    });

    var docs =
        typeof result === "string" || result instanceof String
            ? JSON.parse(result)
            : result;

    var newArray = [];
    for (let i = 0; i < docs.length; i++) {
        newArray[i] = docs[i].doc_id;
    }

    theObject.notSelectedIds = newArray;

    populateDocSelectSection(docs, false, false, globals.dragDropFirst);
    globals.dragDropFirst = false;
}

function initTopicSelectSection(topics) {
    var length = topics.length;
    var device = globals.device;
    var topicsPerSlide = 9;
    var slideHTML = '<div class="swiper-slide"><div class="row"></div></div>';
    var topicHTML =
        '<button class="topic-container"><div class="topic-frame"><div class="topic-bg"></div><div class="topic-checked"></div></div><div class="title-wrapper"><h3></h3></div></button>';

    if (window.innerWidth >= 1200) {
        topicsPerSlide = 15;
    } else if (window.innerWidth >= 992) {
        topicsPerSlide = 12;
    }

    //void the swiper-wrapper
    $("section.topics .swiper-wrapper").empty();
    // how many docs?
    var docsnumber = length + 1;
    // how many slides?
    var slidesnumber = parseInt((docsnumber - 1) / topicsPerSlide) + 1;

    var topic_i = 0;

    for (var i = 0; i < slidesnumber; i++) {
        // for every slide
        $("section.topics .swiper-wrapper").append(slideHTML);
        for (var j = 0; j < topicsPerSlide && topic_i < length; j++) {
            // populate the slides
            if (i == 0 && j == 0) {
                // first slide
                $("section.topics .swiper-slide:last-child .row").append(
                    topicHTML
                );
                $(
                    "section.topics .swiper-slide:last-child .row button.topic-container:last-child"
                ).addClass("select-all");
                $(
                    "section.topics .swiper-slide:last-child .row button.topic-container:last-child h3"
                ).text("Select all");
            } else {
                var topic_id = topics[topic_i].item_id;
                var imageUrl = topics[topic_i].topic_image_url;
                var topic_title = topics[topic_i].topic_title;
                $(
                    "section.topics .swiper-wrapper .swiper-slide:last-child .row"
                ).append(topicHTML);
                $(
                    "section.topics .swiper-slide:last-child .row button.topic-container:last-child"
                ).data("topic_id", topic_id);
                $(
                    "section.topics .swiper-slide:last-child .row button.topic-container:last-child .topic-bg"
                ).css("background-image", "url(" + imageUrl + ")");
                $(
                    "section.topics .swiper-slide:last-child .row button.topic-container:last-child h3"
                ).text(topic_title);
                topic_i++;
            }
        }
    }

    if (slidesnumber > 1) {
        new Swiper("section.topics .swiper-container", {
            // Optional parameters
            pagination: {
                el: "section.topics .swiper-pagination",
                clickable: true
            },
            mousewheel: true
        });
    }

    topicSelect();
}

function initTopicSelect(urls, client_id) {
    $.getJSON(urls.topicselect, {
        client_id: client_id
    }).done(function(json) {
        initTopicSelectSection(json);
    });
}

function preDocModal(selector) {
    let images = selector.data("doc_images_collection");
    let doc_type = selector.data("doc_type");
    let doc_hashtags = selector.data("doc_hashtags");
    let container = $(
        "section.docselect .docmodal .col-left .swiper-container"
    );

    /* DISCARDED!!
      $('section.docselect .docmodal h3').text(
      selector.find('h3').text()
    );
    */

    if (typeof container.get(0).swiper == "object") {
        container.get(0).swiper.destroy();
    }

    const tagsContainer = $(
        "section.docselect .docmodal .col-right .swiper-container"
    );
    if (typeof tagsContainer.get(0).swiper == "object") {
        tagsContainer.get(0).swiper.destroy();
    }

    container
        .removeClass()
        .addClass("modal-swiper swiper-container")
        .addClass(doc_type);
    container.find(".swiper-wrapper").remove();
    container.prepend('<div class="swiper-wrapper"></div>');

    for (var i = 0; i < images.length; i++) {
        if (doc_type == "vertical_pdf") {
            if (i == 0) {
                $(
                    "section.docselect .docmodal .col-left .swiper-wrapper"
                ).append(
                    `<div class="swiper-slide single">
                        <div class="photo-swipe-custom zoom-button pswp__button pswp__button--zoom"></div>
                        <img src="${images[i]}">
                    </div>`
                );
            } else if (i + 1 < images.length) {
                $(
                    "section.docselect .docmodal .col-left .swiper-wrapper"
                ).append(
                    `<div class="swiper-slide">
                        <div class="photo-swipe-custom zoom-button pswp__button pswp__button--zoom"></div>
                        <img src="${images[i]}">
                        <img src="${images[i + 1]}">
                    </div>`
                );
                i++;
            } else {
                $(
                    "section.docselect .docmodal .col-left .swiper-wrapper"
                ).append(
                    `<div class="swiper-slide single">
                        <div class="photo-swipe-custom zoom-button pswp__button pswp__button--zoom"></div>
                        <img src="${images[i]}">
                    </div>`
                );
            }
        } else {
            $("section.docselect .docmodal .col-left .swiper-wrapper").append(
                `<div class="swiper-slide">
                    <div class="photo-swipe-custom zoom-button pswp__button pswp__button--zoom"></div>
                    <img src="${images[i]}">
                </div>`
            );
        }
    }

    $(".photo-swipe-custom").click(function() {
        const clickedSrc = $(this).next()[0].src;
        openPhotoSwipe(images, doc_type, clickedSrc);
    });

    // NEW: Set the title of the document in the modal
    var doc_title = selector.data("doc_title");
    var titleH3 = $("section.docselect .docmodal .modal-content > h3");
    titleH3.text(doc_title);

    var hashcontainer = $(
        "section.docselect .docmodal .col-right .hashtag-container"
    );
    hashcontainer.empty();
    const filterTagsContainer = $(".filter-tags-container");

    gsap.set($(".tags-modal"), { autoAlpha: 0 });

    console.log(doc_hashtags);
    for (var i = 0; i < doc_hashtags.length; i++) {
        //check if the tag is selected in the filter and use selected class
        const tagInFilter = filterTagsContainer.find(
            '.btn-hashtag.selected[data-tag-id="' +
                doc_hashtags[i].tag_id +
                '"]'
        );
        let selected = " selected";
        if (!tagInFilter.length) {
            selected = "";
        }

        hashcontainer.append(
            `<button class="btn btn-hashtag${selected}" data-tag-id="${
                doc_hashtags[i].tag_id
            }"><div class="hashtag-cover"></div> <p>#${
                doc_hashtags[i].tag_name
            }</p></button>`
        );
    }

    hashcontainer.children(".btn-hashtag").click(event => {
        // Listener of clicks that Apply Filter.
        const sel = $(event.currentTarget);
        sel.toggleClass("selected");
        // reflect the tag selection in the filtermodal and trigger a click to make all the filter actions
        filterTagsContainer
            .find('.btn-hashtag[data-tag-id="' + sel.data("tag-id") + '"]')
            .trigger("click");

        const hashessel = hashcontainer.parents(".swiper-container");
        // open modal to apply filter

        if (sel.hasClass("selected")) {
            gsap.to(hashessel, { duration: 0.7, delay: 0.4, autoAlpha: 0 });
            $(".tags-modal").data("tag-id", sel.data("tag-id"));
            gsap.to($(".tags-modal"), {
                duration: 1,
                delay: 0.4,
                autoAlpha: 1
            });
        }
    });
}

function preSelectedMaterials() {
    var selectedHTML =
        '<div class="selected selected-materials-container"><div class="selected-material-wrapper"><div class="cover"><div class="cover-corrected"></div></div><div class="title-wrapper"><h3> Material from your' +
        " session(s)</h3></div></div>";
    // how many docs per Slide?
    var docsPerSlide = 6;

    // how many docs?
    var docsnumber = $(".docselect .drop-zone .doc").length;
    // how many slides?
    var slidesnumber = parseInt(docsnumber / docsPerSlide) + 1;

    //let's clean a bit
    $("section.selected-materials .swiper-wrapper").empty();

    //let's prepare the docs and theObject
    var docsArray = [];
    theObject.SelectedDocs = [];

    $(".docselect .drop-zone .doc").each(function() {
        docsArray.push($(this));
        theObject.SelectedDocs.push($(this).data("doc_id")); // we store all the data_ids in theObject
    });

    var doc_i = 0;

    for (var i = 0; i < slidesnumber; i++) {
        //console.log('hey');
        $("section.selected-materials .swiper-wrapper").append(
            '<div class="swiper-slide w-100"><div class="row"></div></div>'
        );
        for (var j = 0; j < docsPerSlide && doc_i < docsArray.length; j++) {
            let selectedDocs =
                $("section.docselect .right-side .selected").length > 0;
            if (i == 0 && j == 0 && selectedDocs) {
                $(
                    "section.selected-materials .swiper-wrapper .swiper-slide:last-child .row"
                ).append(selectedHTML);
            } else {
                $(
                    "section.selected-materials .swiper-wrapper .swiper-slide:last-child .row"
                ).append(
                    '<div class="selected-materials-container"><div class="selected-material-wrapper">' +
                        docsArray[doc_i].html() +
                        "</div></div>"
                );
                $(
                    "section.selected-materials .swiper-wrapper .swiper-slide:last-child .row div:last-child .cross"
                ).remove();
                $(
                    "section.selected-materials .swiper-wrapper .swiper-slide:last-child .row div:last-child .view"
                ).remove();
                doc_i++;
            }
        }
    }

    if (docsArray.length == 0) {
        if ($("section.docselect .right-side .selected").length > 0) {
            $(
                "section.selected-materials .swiper-wrapper .swiper-slide:last-child .row"
            ).append(selectedHTML);
        }
    }
    const theSwiper = $("section.selected-materials .swiper-container");
    if (slidesnumber > 1) {
        if (
            typeof theSwiper.get("0").swiper != "object" ||
            theSwiper.get("0").swiper == null
        ) {
            new Swiper("section.selected-materials .swiper-container", {
                // Optional parameters
                pagination: {
                    el: "section.selected-materials .swiper-pagination",
                    clickable: true
                },
                mousewheel: true
            });
        } else {
            theSwiper.get("0").swiper.update();
        }
    } else {
        if (typeof theSwiper.get("0").swiper == "object") {
            theSwiper.get("0").swiper.destroy();
            $("section.selected-materials .swiper-pagination").empty();
        }
    }
}

export function mandatoryCheckbox() {
    $("section.selected-materials .btn-section").addClass("disabled");

    $("input.mandatory").on("change", function() {
        if (checkForm()) {
            $("section.selected-materials .btn-section").removeClass(
                "disabled"
            );
        } else {
            $("section.selected-materials .btn-section").addClass("disabled");
        }
    });

    $("input.mandatoryText").on("input", function() {
        if (checkForm()) {
            $("section.selected-materials .btn-section").removeClass(
                "disabled"
            );
        } else {
            $("section.selected-materials .btn-section").addClass("disabled");
        }
    });
}

// NEW: Form validation
function checkForm() {
    var isCorrect = true;

    $("input.mandatoryText").each(function(t) {
        // If false keep false, if true, get this one
        isCorrect = isCorrect ? $(this).val() != "" : false;
    });

    var regeex = new RegExp(/[^@]+@[^\.]+\..+/);
    $("input.mandatoryEmail").each(function(t) {
        // If false keep false, if true, get this one
        isCorrect = isCorrect ? regeex.test($(this).val()) : false;
    });

    $("input.mandatory").each(function(t) {
        // If false keep false, if true, get this one
        isCorrect = isCorrect ? $(this).prop("checked") : false;
    });

    return isCorrect;
}

function emptyFilterModal() {
    const filtersel = $(".filtermodal");
    filtersel.find(".filter-tags-container .swiper-slide").empty();
    filtersel.find(".selected-filters-content .swiper-slide").empty();
}

function checkVScrollbar(scrollbar, swiperel) {
    if (
        !scrollbar.hasClass("sb-invisible") &&
        swiperel.size / swiperel.virtualSize >= 1
    ) {
        TweenMax.fromTo(scrollbar, 0.5, { autoAlpha: 1 }, { autoAlpha: 0 });
        scrollbar.addClass("sb-invisible").removeClass("sb-visible");
    } else if (
        !scrollbar.hasClass("sb-visible") &&
        swiperel.size / swiperel.virtualSize < 1
    ) {
        TweenMax.fromTo(scrollbar, 0.5, { autoAlpha: 0 }, { autoAlpha: 1 });
        scrollbar
            .addClass("sb-visible")
            .removeClass("sb-invisible")
            .removeClass("scrollbar-none");
    }
}

function checkClearFilterBtnStatus(added) {
    const btn = $(".btn-clear-sel-2");
    const btnctn = $(".selected-filters-content .swiper-slide");
    if (added) {
        btn.removeClass("disabled");
    } else {
        if (!btnctn.children().length) {
            btn.addClass("disabled");
        }
    }
}

function populateFilterModal(url, client_id, topics) {
    $.getJSON(url, {
        client_id: client_id,
        topics: topics
    }).done(function(json) {
        populateFilterModalHTML(json);
    });

    function populateFilterModalHTML(info) {
        const theModalContent = $(
            ".filtermodal .filter-tags-container .swiper-slide"
        );
        info.forEach((category, index) => {
            // generate div of category
            let tempHTML = `<div class="cat-container" data-cat-id="${
                category.category_id
            }">
      <div class="cat-folder">
      <div class="cat-vsym"></div>
      <div class="cat-hsym"></div>
      </div>
      <h4 class="cat-title">${category.category_title}</h4>
      </div>`;

            theModalContent.append(tempHTML);

            // generate container of tags
            tempHTML = `<div class="cattags-container row">
      </div>`;
            theModalContent.append(tempHTML);
            let tagscontainer = theModalContent.find(
                ".cattags-container:last-child"
            );

            // each categorytags
            $.each(category.category_tags, (index, tag) => {
                if (tag.tag_doc_count == 0) {
                    return;
                } // if no items don't show

                // generate tag markup
                tagscontainer.append(
                    `<button class="btn btn-hashtag" data-tag-id="${
                        tag.tag_id
                    }"><div class="hashtag-cover"></div> <p>#${
                        tag.tag_name
                    } | ${
                        tag.tag_doc_count
                    }</p><img src="${baseUrl}/assets/images/close.svg"/></button>`
                );
            });
            //check if it's empty and remove category and tags
            if (tagscontainer.children().length === 0) {
                const catcontainer = tagscontainer.prev();
                catcontainer.remove();
                tagscontainer.remove();
            } else {
                // add dummy for padding-bottom
                tagscontainer.append('<div class="spacer"></div>');
            }
        });

        // activate swiper
        new Swiper(".filtermodal .filter-tags-container .swiper-container", {
            direction: "vertical",
            slidesPerView: "auto",
            freeMode: true,
            scrollbar: {
                el: ".swiper-scrollbar"
            },
            mousewheel: true
        });

        // activate swiper of 'your filters'
        new Swiper(".filtermodal .selected-filters-content .swiper-container", {
            direction: "vertical",
            slidesPerView: "auto",
            freeMode: true,
            scrollbar: {
                el: ".your-filters-swiper-scrollbar"
            },
            mousewheel: true
        });

        // activate listener of folder
        $(".cat-folder").click(event => {
            const sel = $(event.currentTarget);
            const tagssel = sel.parent().next();

            TweenMax.set(tagssel, { scaleX: 1 });
            const filterswiper = $(
                ".filtermodal .filter-tags-container .swiper-container"
            ).get(0).swiper;
            const scrollbar = $(
                ".filtermodal .swiper-container-vertical > .swiper-scrollbar"
            );

            if (sel.hasClass("unfolded")) {
                // fold the tags
                sel.removeClass("unfolded");
                TweenMax.fromTo(
                    tagssel,
                    0.5,
                    { height: "auto", autoAlpha: 1, scaleY: 1 },
                    {
                        height: 0,
                        autoAlpha: 0,
                        scaleY: 0,
                        onComplete: () => {
                            if (typeof filterswiper == "object") {
                                filterswiper.update();
                                filterswiper.update();
                                checkVScrollbar(scrollbar, filterswiper);
                            }
                        }
                    }
                );
            } else {
                // unfold the tags
                sel.addClass("unfolded");
                TweenMax.fromTo(
                    tagssel,
                    0.5,
                    { height: 0, autoAlpha: 0, scaleY: 0 },
                    {
                        height: "auto",
                        autoAlpha: 1,
                        scaleY: 1,
                        onComplete: () => {
                            if (typeof filterswiper == "object") {
                                filterswiper.update();
                                filterswiper.update();
                                checkVScrollbar(scrollbar, filterswiper);
                                contentScrollToLast(filterswiper, tagssel);
                                // TODO: PR2 if the contents are outside of the swiper we should scroll
                            }
                        }
                    }
                );
            }
        });
        // click should happen on the text too
        $(".cat-title").click(e => {
            $(e.currentTarget)
                .prev()
                .trigger("click");
        });

        //activate listener of tags
        $(".cattags-container .btn-hashtag").click(event => {
            if (!globals.animating) {
                hashtagClickAction(event);
            }
        });

        // listener of clicks outside of "your filters"
        const selfiltercontainer = $(".selected-filters-container");
        $(".filtermodal").click(e => {
            const translateContainer =
                selfiltercontainer.get(0).getBoundingClientRect().width -
                $(".your-filters-wrapper")
                    .get(0)
                    .getBoundingClientRect().width;
            if (
                !$(e.target).parents(".selected-filters-container").length &&
                !(
                    $(e.target).is("img") &&
                    $(e.target).parents(".btn-hashtag").length
                )
            ) {
                // you clicked outside of your filters

                if (!selfiltercontainer.hasClass("folded")) {
                    foldSelectedFilters(
                        selfiltercontainer,
                        translateContainer,
                        1
                    );
                    selfiltercontainer.addClass("folded");
                } else {
                    if (
                        $(e.target).hasClass("your-filters-wrapper") ||
                        $(e.target).parents(".your-filters-wrapper").length
                    ) {
                        selfiltercontainer.removeClass("folded");
                        foldSelectedFilters(
                            selfiltercontainer,
                            translateContainer,
                            -1
                        );
                    }
                }
            }
        });
    }

    function foldSelectedFilters(selfiltercontainer, tcontainer, type) {
        const arrows = $(".your-filters-sel img");
        if (type == 1) {
            TweenMax.fromTo(
                selfiltercontainer.parent(),
                1,
                { x: 0 },
                { x: tcontainer }
            );
            TweenMax.fromTo(arrows, 1, { rotation: 0 }, { rotation: 180 });
        } else {
            TweenMax.fromTo(
                selfiltercontainer.parent(),
                1,
                { x: tcontainer },
                { x: 0 }
            );
            TweenMax.fromTo(arrows, 1, { rotation: 180 }, { rotation: 360 });
        }
    }

    function selectedFiltersDestroyAction(selector) {
        // find same selector in left side and deselect
        const tagDomSelector = $(
            '.filtermodal .filter-tags-container .btn-hashtag[data-tag-id="' +
                selector.data("tag-id") +
                '"]'
        );

        tagDomSelector.removeClass("selected");

        // first we take the positions of the rest of the elements
        let currentsel = selector;
        let currentpos = [];
        let afterpos = [];
        while (currentsel.next().length) {
            currentsel = currentsel.next();
            currentpos.push(currentsel.get(0).getBoundingClientRect());
        }
        // we dnone the element
        gsap.set(selector, { display: "none" });
        // we take the positions again
        currentsel = selector;
        while (currentsel.next().length) {
            currentsel = currentsel.next();
            afterpos.push(currentsel.get(0).getBoundingClientRect());
        }
        // we display it again
        gsap.set(selector, { display: "inline-block" });
        // we scale the element to zero
        gsap.to(selector, { scale: 0, duration: 0.6 });
        // we move all the other elements to the final positions
        currentsel = selector;
        let i = 0;
        while (currentsel.next().length) {
            currentsel = currentsel.next();
            gsap.to(currentsel, {
                duration: 0.6,
                x: afterpos[i].x - currentpos[i].x,
                y: afterpos[i].y - currentpos[i].y,
                onComplete: () => {
                    // on complete we remove the element and perform rest of actions
                    if (!currentsel.next().length) {
                        let currentsel2 = selector;
                        gsap.set(selector, { display: "none" });
                        while (currentsel2.next().length) {
                            currentsel2 = currentsel2.next();
                            gsap.set(currentsel2, { x: 0, y: 0 });
                        }

                        setTimeout(() => {
                            // because we use the selector to know the next nodes, we can't remove it as it affects the while executing in parallel
                            selector.remove();
                        }, 10);

                        checkClearFilterBtnStatus(false);
                        const yourfilterswiper = $(
                            ".filtermodal .selected-filters .swiper-container"
                        ).get(0).swiper;
                        if (typeof yourfilterswiper == "object") {
                            yourfilterswiper.update();
                            checkVScrollbar(
                                $(".your-filters-swiper-scrollbar"),
                                yourfilterswiper
                            );
                        }
                    }
                }
            });
            i++;
        }
    }

    function hashtagClickAction(event) {
        const sel = $(event.currentTarget);
        const yourfilterswiper = $(
            ".filtermodal .selected-filters .swiper-container"
        ).get(0).swiper;
        if (sel.hasClass("selected")) {
            // the tag has been unselected
            sel.removeClass("selected");

            // remove from 'your filters'
            const rightTagSelectorToRemove = $(
                '.filtermodal .selected-filters-content .btn-hashtag[data-tag-id="' +
                    sel.data("tag-id") +
                    '"]'
            );
            gsap.to(rightTagSelectorToRemove, {
                scale: 0,
                autoAlpha: 0,
                duration: 1,
                onComplete: function() {
                    rightTagSelectorToRemove.remove();
                    checkClearFilterBtnStatus(false);
                    if (typeof yourfilterswiper == "object") {
                        yourfilterswiper.update();
                        checkVScrollbar(
                            $(".your-filters-swiper-scrollbar"),
                            yourfilterswiper
                        );
                    }
                }
            });
        } else {
            // the tag has been selected
            sel.addClass("selected");

            const movedsel = sel.clone();
            movedsel.appendTo(".selected-filters-content .swiper-slide");
            gsap.set(movedsel, { scale: 0 });
            gsap.to(movedsel, {
                scale: 1,
                autoAlpha: 1,
                duration: 1,
                onComplete: function() {
                    if (typeof yourfilterswiper == "object") {
                        yourfilterswiper.update();
                        checkVScrollbar(
                            $(".your-filters-swiper-scrollbar"),
                            yourfilterswiper
                        );
                    }
                }
            });

            // listen to closing events in new button in the right
            movedsel.find("img").click(e => {
                selectedFiltersDestroyAction($(e.currentTarget).parent());
                const tags = []; // prepare all selected tags for the json call
                $(".cattags-container .btn-hashtag.selected").each(
                    (index, el) => {
                        tags.push($(el).data("tag-id"));
                    }
                );

                filterCatsRegenerate(urls, tags);
            });
            checkClearFilterBtnStatus(true);
        }
        const tags = []; // prepare all selected tags for the json call
        $(".cattags-container .btn-hashtag.selected").each((index, el) => {
            tags.push($(el).data("tag-id"));
        });
        filterCatsRegenerate(urls, tags);
    }

    function filterCatsRegenerate(urls, tags) {
        $.getJSON(urls.filterCatsRegenerate, {
            tags: tags
        }).done(function(json) {
            filterCatsRegenerateMarkup(json);
        });
    }

    // NEW: Regenerate everything when closing the modal

    $(".btn-cancel-sel").click(event => {
        clearFilterTags();

        filterCatsRegenerate(urls, []);
        let filterTags = [];
        // revisamos todos los hashtags que tienen select en la izquierda y los enviamos al JSON
        $(".cattags-container .btn-hashtag.selected").each((index, el) => {
            filterTags.push($(el).data("tag-id"));
        });
        console.log(filterTags);

        // llamar a JSON para nuevos documentos (igual que docselect)
        initDocSelect(urls, theObject.client_id, theObject.SelectedTopics);
        // closeModal($(event.currentTarget).closest('.filtermodal'));
        // $('.docselect .buttons-container').addClass('filtered-state');
    });
    $(".btn-clear-sel-2").click(event => {
        clearFilterTags();

        filterCatsRegenerate(urls, []);
        let filterTags = [];
        // revisamos todos los hashtags que tienen select en la izquierda y los enviamos al JSON
        $(".cattags-container .btn-hashtag.selected").each((index, el) => {
            filterTags.push($(el).data("tag-id"));
        });
        console.log(filterTags);

        // llamar a JSON para nuevos documentos (igual que docselect)
        initDocSelect(urls, theObject.client_id, theObject.SelectedTopics);
        // closeModal($(event.currentTarget).closest('.filtermodal'));
        // $('.docselect .buttons-container').addClass('filtered-state');
    });
    $(".btn-clear").click(event => {
        clearFilterTags();

        filterCatsRegenerate(urls, []);
        let filterTags = [];
        // revisamos todos los hashtags que tienen select en la izquierda y los enviamos al JSON
        $(".cattags-container .btn-hashtag.selected").each((index, el) => {
            filterTags.push($(el).data("tag-id"));
            console.log(el);
        });
        console.log(filterTags);

        // llamar a JSON para nuevos documentos (igual que docselect)
        initDocSelect(urls, theObject.client_id, theObject.SelectedTopics);
        // closeModal($(event.currentTarget).closest('.filtermodal'));
        // $('.docselect .buttons-container').addClass('filtered-state');
    });

    function filterCatsRegenerateMarkup(data) {
        //console.log(data);

        $.each(data, (index, category) => {
            // this is a category
            const catContainer = $(
                '.cat-container[data-cat-id="' + category.category_id + '"]'
            );
            // check if folded (then not animate)
            const unfolded = catContainer
                .children(".cat-folder")
                .hasClass("unfolded");
            let initialTagsArray = [];
            let toRemoveArray = [];
            let toUpdateArray = [];
            let toAddArray = [];

            // save the positions of each tag
            catContainer
                .next()
                .children(".btn-hashtag")
                .each((index, element) => {
                    initialTagsArray[
                        $(element).data("tag-id")
                    ] = element.getBoundingClientRect();
                });

            // for each current tag
            //if the tag is removed
            // add to the arrays to remove
            // check for new tags, and add them to the array
            $.each(category.tags_changed, (index, tag) => {
                if (typeof initialTagsArray[tag.tag_id] !== "undefined") {
                    if (tag.tag_doc_count == 0) {
                        toRemoveArray.push(tag.tag_id);
                    } else {
                        toUpdateArray[tag.tag_id] = {
                            name: tag.tag_name,
                            count: tag.tag_doc_count
                        };
                    }
                } else if (tag.tag_doc_count > 0) {
                    toAddArray[tag.tag_id] = {
                        name: tag.tag_name,
                        count: tag.tag_doc_count
                    };
                }
            });

            let newTagsInitialArray = [];
            // add the new tags
            $.each(toAddArray, (index, details) => {
                if (typeof details != "undefined") {
                    const selector = catContainer.next().children(".spacer");
                    selector.before(
                        `<button class="btn btn-hashtag" data-tag-id="${index}"><div class="hashtag-cover"></div> <p>#${
                            details.name
                        } | ${
                            details.count
                        }</p><img src="${baseUrl}/assets/images/close.svg"/></button>`
                    );
                    // take the new positions
                    newTagsInitialArray[index] = selector
                        .prev()
                        .get(0)
                        .getBoundingClientRect();
                    // add the click listener
                    selector.prev().click(event => {
                        hashtagClickAction(event);
                    });
                }
            });

            // display none all the tags that need removing

            let finalTagsArray = [];
            let newTagsFinalArray = [];
            catContainer
                .next()
                .children(".btn-hashtag")
                .each((index, element) => {
                    if (
                        toRemoveArray.indexOf($(element).data("tag-id")) != -1
                    ) {
                        $(element).css("display", "none");

                        // remove from 'your filters' if necessary
                        const rightTagSelectorToRemove = $(
                            '.filtermodal .selected-filters-content .btn-hashtag[data-tag-id="' +
                                $(element).data("tag-id") +
                                '"]'
                        );
                        if (rightTagSelectorToRemove.length) {
                            gsap.to(rightTagSelectorToRemove, {
                                scale: 0,
                                autoAlpha: 0,
                                duration: 1,
                                onComplete: function() {
                                    rightTagSelectorToRemove.remove();
                                    checkClearFilterBtnStatus(false);
                                    const yourfilterswiper = $(
                                        ".filtermodal .selected-filters .swiper-container"
                                    ).get(0).swiper;
                                    if (typeof yourfilterswiper == "object") {
                                        yourfilterswiper.update();
                                        checkVScrollbar(
                                            $(".your-filters-swiper-scrollbar"),
                                            yourfilterswiper
                                        );
                                    }
                                }
                            });
                        }

                        // if no animation required, just remove
                        if (!unfolded) {
                            $(element).remove();
                        }
                    } else if (
                        typeof toUpdateArray[$(element).data("tag-id")] !=
                        "undefined"
                    ) {
                        // modify the modifiable ones
                        $(element)
                            .find("p")
                            .text(
                                "#" +
                                    toUpdateArray[$(element).data("tag-id")]
                                        .name +
                                    " | " +
                                    toUpdateArray[$(element).data("tag-id")]
                                        .count
                            );

                        // take the new positions
                        finalTagsArray[
                            $(element).data("tag-id")
                        ] = element.getBoundingClientRect();
                    } else if (
                        typeof toAddArray[$(element).data("tag-id")] !=
                        "undefined"
                    ) {
                        newTagsFinalArray[
                            $(element).data("tag-id")
                        ] = element.getBoundingClientRect();
                        if (unfolded) {
                            gsap.set(element, { scale: 0, autoAlpha: 0 });
                        }
                    } else {
                        // take the new positions
                        finalTagsArray[
                            $(element).data("tag-id")
                        ] = element.getBoundingClientRect();
                    }
                });

            // Now only execute animations if unfolded:
            if (!unfolded) {
                catContainer
                    .parents(".swiper-container")
                    .get(0)
                    .swiper.update();
                return;
            }

            // display the not displayed again
            $.each(toRemoveArray, (index, tag_id) => {
                catContainer
                    .next()
                    .children('.btn-hashtag[data-tag-id="' + tag_id + '"]')
                    .removeAttr("style");
            });

            //now animate everything with all the known positions and execute oncomplete for the last one
            const looplength = catContainer.next().children(".btn-hashtag")
                .length;
            catContainer
                .next()
                .children(".btn-hashtag")
                .each((index, element) => {
                    if (
                        toRemoveArray.indexOf($(element).data("tag-id")) != -1
                    ) {
                        // item to remove
                        gsap.to(element, {
                            duration: 0.5,
                            scale: 0,
                            autoAlpha: 0,
                            onComplete: () => {
                                if (looplength == index + 1) {
                                    removeStylesUpdateSwiper(
                                        catContainer,
                                        toRemoveArray
                                    );
                                }
                            }
                        });
                    } else if (
                        typeof toAddArray[$(element).data("tag-id")] !=
                        "undefined"
                    ) {
                        const xdif =
                            newTagsFinalArray[$(element).data("tag-id")].x -
                            newTagsInitialArray[$(element).data("tag-id")].x;
                        const ydif =
                            newTagsFinalArray[$(element).data("tag-id")].y -
                            newTagsInitialArray[$(element).data("tag-id")].y;
                        // scale to 1 the new ones
                        globals.animating = true;
                        gsap.to(element, {
                            duration: 0.5,
                            scale: 1,
                            autoAlpha: 1,
                            x: xdif,
                            y: ydif,
                            onComplete: () => {
                                if (looplength == index + 1) {
                                    removeStylesUpdateSwiper(
                                        catContainer,
                                        toRemoveArray
                                    );
                                    globals.animating = false;
                                }
                            }
                        });
                    } else {
                        const xdif =
                            finalTagsArray[$(element).data("tag-id")].x -
                            initialTagsArray[$(element).data("tag-id")].x;
                        const ydif =
                            finalTagsArray[$(element).data("tag-id")].y -
                            initialTagsArray[$(element).data("tag-id")].y;
                        globals.animating = true;
                        gsap.to(element, {
                            duration: 0.5,
                            x: xdif,
                            y: ydif,
                            onComplete: () => {
                                if (looplength == index + 1) {
                                    removeStylesUpdateSwiper(
                                        catContainer,
                                        toRemoveArray
                                    );
                                    globals.animating = false;
                                }
                            }
                        });
                    }
                });
        });

        function removeStylesUpdateSwiper(catContainer, toRemoveArray) {
            // on complete, remove all styles and refresh swiper
            catContainer
                .next()
                .children(".btn-hashtag")
                .each((index, element) => {
                    if (
                        toRemoveArray.indexOf($(element).data("tag-id")) != -1
                    ) {
                        $(element).remove();
                    } else {
                        gsap.set(element, { x: 0, y: 0 });
                    }
                });
            catContainer
                .parents(".swiper-container")
                .get(0)
                .swiper.update();
        }
    }

    function contentScrollToLast(theSwiper, tagssel) {
        // take last button
        const lastbuttonRect = tagssel
            .find(".btn-hashtag")
            .last()
            .get(0)
            .getBoundingClientRect();
        // check if it's outside of view
        const swiperRect = $(".filtermodal .modal-content .swiper-container")
            .get(0)
            .getBoundingClientRect();
        const thresold =
            swiperRect.y + swiperRect.height - lastbuttonRect.height;
        console.log(thresold);
        console.log(lastbuttonRect.y);

        if (lastbuttonRect.y > thresold) {
            // scroll to tag container
            const translateValue =
                tagssel
                    .prev()
                    .get(0)
                    .getBoundingClientRect().y - swiperRect.y;
            theSwiper.translateTo(-translateValue, 600);
        }
    }
}

function clearFilterTags() {
    $(".selected-filters-content .swiper-slide").empty();
    $(".filter-tags-container .selected").removeClass("selected");
    $(".cat-folder.unfolded").trigger("click");
}

export function filterButtonListener() {
    hideTheModal($(".filtermodal")); // done

    $(".btn-filter-sel").click(() => {
        gsap.set($(".selected-filters"), { x: 0 });
        gsap.set($(".your-filters-sel img"), { rotation: 0 });
        $(".selected-filters-container").removeClass("folded");
        showModal($(".filtermodal"), () => {
            const filterswiper = $(
                ".filtermodal .modal-content .swiper-container"
            ).get(0).swiper;
            if (typeof filterswiper == "object") {
                filterswiper.update();
                checkVScrollbar($(".swiper-scrollbar"), filterswiper);
            }
            const yourfilterswiper = $(
                ".filtermodal .selected-filters .swiper-container"
            ).get(0).swiper;
            if (typeof yourfilterswiper == "object") {
                yourfilterswiper.update();
                checkVScrollbar(
                    $(".your-filters-swiper-scrollbar"),
                    yourfilterswiper
                );
            }
        });
    });

    $(".btn-cancel-sel").click(event =>
        closeModal($(event.currentTarget).closest(".filtermodal"))
    );
    $(".btn-clear-sel-2").click(event => {
        if (!$(event.currentTarget).hasClass("disabled")) {
            clearFilterTags();
            checkClearFilterBtnStatus(false);
            const yourfilterswiper = $(
                ".filtermodal .selected-filters .swiper-container"
            ).get(0).swiper;
            if (typeof yourfilterswiper == "object") {
                yourfilterswiper.update();
                checkVScrollbar(
                    $(".your-filters-swiper-scrollbar"),
                    yourfilterswiper
                );
            }
        }
    });
}

export function devGoToDocSelect() {
    function devpageChange(currentSection) {
        const body = $("body");
        let nextSection = currentSection.next("section"); // ho canviarem a your selected materials
        body.removeClass();
        currentSection.removeClass("active");
        nextSection.addClass("active");
        body.addClass(nextSection.attr("id"));
    }

    devpageChange($("section.home"));

    initTopicSelect(urls, theObject.client_id);
    devpageChange($("section.client"));
    theObject.SelectedTopics = [];

    initDocSelect(urls, theObject.client_id, theObject.SelectedTopics);
    emptyFilterModal(); // done move to topix
    populateFilterModal(
        urls.filterCats,
        theObject.client_id,
        theObject.SelectedTopics
    );
    devpageChange($("section.topics"));
}

// NEW: Initializes the privacy policy modal. Modal is not actually used, so we're only using it to open another tab when the user clicks the button
export function privacyPolicyInit() {
    // Hide privacy policy when clicking outside
    $(document).click(function(event) {
        var target = $(event.target);
        if (
            !target.closest("#privacyPolicyIframe").length &&
            target.attr("id") != "privacyPolicyButton" &&
            $("#privacyPolicyDiv").is(":visible")
        ) {
            // Hide the Privacy Policy and reload it, in case they clicked a link
            $("#privacyPolicyDiv").css("display", "none");
            document.getElementById("privacyPolicyIframe").src += "";
        }
    });

    $("#privacyPolicyButton").click(function(event) {
        // Show the Privacy policy
        window.open(
            "https://www.accenture.com/us-en/about/privacy-policy?src=SOMS",
            "_blank"
        );
        // $('#privacyPolicyDiv').css('display', '');
    });
}

function openPhotoSwipe(images, doc_type, clickedSrc) {
    const width = doc_type === "vertical_pdf" ? 1391 : 1800;
    const height = doc_type === "vertical_pdf" ? 1800 : 1012;

    const pswpElement = document.querySelectorAll(".pswp")[0];
    const items = images.map(image => ({ src: image, w: width, h: height }));

    const index = items.findIndex(item => item.src === clickedSrc);

    const options = {
        index: index,
        captionEl: false,
        tapToClose: false,
        shareEl: false,
        fullscreenEl: false
    };
    const gallery = new PhotoSwipe(
        pswpElement,
        PhotoSwipeUI_Default,
        items,
        options
    );
    gallery.init();
}
